import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, clearToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [agency, setAgency] = useState(null);

  const loadAgency = async () => {
    try {
      const { data } = await api.get("/agency");
      setAgency(data);
      if (data?.accent_color) document.documentElement.style.setProperty("--accent", data.accent_color);
    } catch (e) {}
  };

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        loadAgency();
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.access_token) setToken(data.access_token);
    setUser(data.user);
    loadAgency();
    return data.user;
  };

  const googleLogin = async (credential) => {
    const { data } = await api.post("/auth/google", { credential });
    if (data?.access_token) setToken(data.access_token);
    setUser(data.user);
    loadAgency();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    clearToken();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, agency, setAgency, login, googleLogin, logout, loadAgency }}>
      {children}
    </AuthCtx.Provider>
  );
}
